import { Box, Grid, List, Typography, useTheme } from "@mui/material";
import GeneratedAlbum from "components/listItems/GeneratedAlbum/GeneratedAlbum";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import LoadingSpinner from "components/ui/LoadingSpinner/LoadingSpinner";
import React, { useContext } from "react";
import { UserContext } from "utils/UserContext";

function SearchResults() {
  const { albumsLoading, albums, searched } = useContext(UserContext);

  const mainTheme = useTheme();

  // Only render the result section when the search has been conducted
  return (
    <Box component="section">
      {searched && (
        <CenteredColumnGrid container>
          {albumsLoading ? (
            <Grid item>
              <LoadingSpinner />
            </Grid>
          ) : (
            <Grid item>
              <Box>
                {albums.length === 0 && !albumsLoading ? (
                  <Typography variant="body1">No Results</Typography>
                ) : (
                  <List
                    sx={{
                      padding: "5px",
                      margin: "10px 0",
                      backgroundColor: mainTheme.palette.darkGraySecondary.main,
                      borderRadius: "1.25rem",
                    }}
                  >
                    {albums.map((album) => (
                      <GeneratedAlbum
                        key={album.id}
                        id={album.id}
                        img={album.img}
                        name={album.name}
                        mainArtist={album.mainArtist}
                        album={album}
                      />
                    ))}
                  </List>
                )}
              </Box>
            </Grid>
          )}
        </CenteredColumnGrid>
      )}
    </Box>
  );
}

export default SearchResults;
